import { useContext } from "react";
import { MultiplayerContext } from "./MultiplayerContext";
import {
  BackendEventType,
  CursorPointerWebsocketMessageResponse,
  EventType,
  MultiplayerBasePayloadType,
} from "../../types/Multiplayer.types";

export const useMultiplayer = () => {
  const {
    loading,
    socket,
    isConnected,
    addEventListener,
    removeEventListener,
    subscribeToDesign,
    unsubscribeFromDesign,
    subscribeToProject,
    unsubscribeFromProject,
    subscribeToTeam,
    unsubscribeFromTeam,
    sendCursorPosition,
  } = useContext(MultiplayerContext);

  return {
    loading,
    socket,
    isConnected,
    addEventListener,
    removeEventListener,
    subscribeToDesign,
    unsubscribeFromDesign,
    subscribeToProject,
    unsubscribeFromProject,
    subscribeToTeam,
    unsubscribeFromTeam,
    sendCursorPosition,
    // Helper methods for common events
    onDesignJoin: (handler: (payload: MultiplayerBasePayloadType) => void) =>
      addEventListener(EventType.JOIN_DESIGN, handler),
    removeDesignJoin: (
      handler: (payload: MultiplayerBasePayloadType) => void
    ) => removeEventListener(EventType.JOIN_DESIGN, handler),

    onDesignLeave: (handler: (payload: MultiplayerBasePayloadType) => void) =>
      addEventListener(EventType.LEAVE_DESIGN, handler),
    removeDesignLeave: (
      handler: (payload: MultiplayerBasePayloadType) => void
    ) => removeEventListener(EventType.LEAVE_DESIGN, handler),

    onDesignUpdate: (handler: (payload: MultiplayerBasePayloadType) => void) =>
      addEventListener(BackendEventType.DESIGN_UPDATE, handler),
    removeDesignUpdate: (
      handler: (payload: MultiplayerBasePayloadType) => void
    ) => removeEventListener(BackendEventType.DESIGN_UPDATE, handler),

    onWhoIsInDesign: (handler: (payload: MultiplayerBasePayloadType) => void) =>
      addEventListener(EventType.WHO_IS_IN_THE_DESIGN, handler),
    removeWhoIsInDesign: (
      handler: (payload: MultiplayerBasePayloadType) => void
    ) => removeEventListener(EventType.WHO_IS_IN_THE_DESIGN, handler),

    onProjectJoin: (handler: (payload: MultiplayerBasePayloadType) => void) =>
      addEventListener(EventType.JOIN_PROJECT, handler),
    removeProjectJoin: (
      handler: (payload: MultiplayerBasePayloadType) => void
    ) => removeEventListener(EventType.JOIN_PROJECT, handler),

    onProjectLeave: (handler: (payload: MultiplayerBasePayloadType) => void) =>
      addEventListener(EventType.LEAVE_PROJECT, handler),
    removeProjectLeave: (
      handler: (payload: MultiplayerBasePayloadType) => void
    ) => removeEventListener(EventType.LEAVE_PROJECT, handler),

    onWhoIsInProject: (
      handler: (payload: MultiplayerBasePayloadType) => void
    ) => addEventListener(EventType.WHO_IS_IN_THE_PROJECT, handler),
    removeWhoIsInProject: (
      handler: (payload: MultiplayerBasePayloadType) => void
    ) => removeEventListener(EventType.WHO_IS_IN_THE_PROJECT, handler),

    onCollaboratorsLocationUpdate: (
      handler: (payload: MultiplayerBasePayloadType) => void
    ) => addEventListener(EventType.UPDATE_COLLABORATORS_LOCATION, handler),
    removeCollaboratorsLocationUpdate: (
      handler: (payload: MultiplayerBasePayloadType) => void
    ) => removeEventListener(EventType.UPDATE_COLLABORATORS_LOCATION, handler),

    onTeamJoin: (handler: (payload: MultiplayerBasePayloadType) => void) =>
      addEventListener(EventType.JOIN_TEAM, handler),
    removeTeamJoin: (handler: (payload: MultiplayerBasePayloadType) => void) =>
      removeEventListener(EventType.JOIN_TEAM, handler),

    onTeamLeave: (handler: (payload: MultiplayerBasePayloadType) => void) =>
      addEventListener(EventType.LEAVE_TEAM, handler),
    removeTeamLeave: (handler: (payload: MultiplayerBasePayloadType) => void) =>
      removeEventListener(EventType.LEAVE_TEAM, handler),
    onWhoIsInTeam: (handler: (payload: MultiplayerBasePayloadType) => void) =>
      addEventListener(EventType.WHO_IS_IN_THE_TEAM, handler),
    removeWhoIsInTeam: (
      handler: (payload: MultiplayerBasePayloadType) => void
    ) => removeEventListener(EventType.WHO_IS_IN_THE_TEAM, handler),

    onCursorPosition: (
      handler: (
        payload: MultiplayerBasePayloadType<CursorPointerWebsocketMessageResponse>
      ) => void
    ) => addEventListener(EventType.CURSOR_POSITION, handler),
    removeCursorPosition: (
      handler: (
        payload: MultiplayerBasePayloadType<CursorPointerWebsocketMessageResponse>
      ) => void
    ) => removeEventListener(EventType.CURSOR_POSITION, handler),
  };
};
